import { render, staticRenderFns } from "./MenuDate.vue?vue&type=template&id=3bd100e5"
import script from "./MenuDate.vue?vue&type=script&lang=js"
export * from "./MenuDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports